import { render, staticRenderFns } from "./BindBanner.vue?vue&type=template&id=1244cebb&scoped=true"
import script from "./BindBanner.vue?vue&type=script&lang=js"
export * from "./BindBanner.vue?vue&type=script&lang=js"
import style0 from "./BindBanner.vue?vue&type=style&index=0&id=1244cebb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244cebb",
  null
  
)

export default component.exports